// rosterGrup.js — ROSTER SATIR GRUBU (tek kaynak)
//
// Roster tablosu, roster ay kâğıdı (21 Eki 2026) ve DUTY HISTORY'den açılan EDIT aynı gruplamayı kullanır. Eskiden
// FTLPanel'in içindeydi; ay kâğıdını üreten `DutySheet.js` FTLPanel'i içe aktaramadığı için (döngü) buraya taşındı.

// EDIT GRUBU ANAHTARI — tek kaynak (3 Eki 2026): roster'ın EDIT'i ve DUTY HISTORY çizelgesinden açılan EDIT aynı grubu
// açar (atamanın satırları; ataması olmayan görev tek başına).
const grupAnahtari = (d) => d.assignment_id || `solo-${d.id}`;
// SATIR GRUBU (4 Eki 2026, Serkan: *"SCL tek başına olması gerekmez mi"* · *"o zaman başla, aksi halde manasız"*): bir
// atamanın İPTAL edilmiş kayıtları canlı kayıtlarından AYRI satırdır. 🔴 Önce atama tek satırdı ve durum İLK kaydınkiydi:
// 9 Eki ofisinde SEL ve AAK iptal, SCL planlı → satır "CANCELLED" diyor, SCL'nin planlı ofisi iptal görünüyordu; SEL/AAK
// ikinci atamalarıyla iki canlı satırda görünüyordu. EDIT / CANCEL de yalnız o satırın kayıtlarına uygulanır — iptal
// edilmiş üye EDIT'in ekibine girmez. Roster ve DUTY HISTORY çizelgesinden açılan EDIT bu anahtarı kullanır (tek kaynak).
export const satirGrubuAnahtari = (d) => `${grupAnahtari(d)}|${d.status === 'cancelled' ? 'iptal' : 'canli'}`;
export const satirGrubu = (duties, d) => {
  const k = satirGrubuAnahtari(d);
  return (duties || []).filter(x => satirGrubuAnahtari(x) === k);
};
/** Roster tablosunun satırları: aralıktaki kayıtlar satır grubuna göre, tarihe ve rapora göre sıralı. */
export function rosterGruplari(duties, from, to) {
  const map = new Map();
  (duties || []).filter(d => d.duty_date >= from && d.duty_date <= to).forEach(d => {
    const k = satirGrubuAnahtari(d);
    if (!map.has(k)) map.set(k, []);
    map.get(k).push(d);
  });
  return [...map.entries()]
    .map(([k, rs]) => ({ key: k, rows: rs, head: rs[0] }))
    .sort((a, b) => (a.head.duty_date || '').localeCompare(b.head.duty_date || '')
                 || String(a.head.report_time).localeCompare(String(b.head.report_time)));
}
